import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Model } from 'src/app/app.model';
import { Subscription } from 'src/app/subscription/subscription.model';
import { SubscriptionService } from 'src/app/subscription/subscription.service';
import { WorkflowEndcustomerService } from '../workflow-endcustomer.service';
import { WorkflowComponent } from '../../workflow.component';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-workflow-endcustomer-ai-tariff-order-cancel',
  templateUrl: './workflow-endcustomer-ai-tariff-order-cancel.component.html',
  standalone: false
})
export class WorkflowEndcustomerAiTariffOrderCancelComponent extends WorkflowComponent implements OnInit {

  public subscription: Subscription;

  constructor(
    protected route: ActivatedRoute,
    protected m: Model,
    protected router: Router,
    protected subscriptionService: SubscriptionService,
    protected workflowEndcustomerService: WorkflowEndcustomerService,
  ) {
    super();
  }

  async ngOnInit() {
    super.ngOnInit();
    this.setStep('order-cancel');
    this.subscriptionService.getSubscriptionDetails(+this.applianceId).subscribe({
      next: (r) => {
        this.subscription = Subscription.fromJson(r);
        this.applianceId = this.subscription.appliance_id;
      },
      error: (err) => {
        this.router.navigate(['/subscriptions']);
        this.resetWorkflow();
      }
    });
  }

  private setStep(step: string) {
    this.step = step;
  }

  onBack() {
    this.resetWorkflow();
  }

  async onConfirm() {
    try {
      const orderWithAiTariff = this.subscription?.scheduledAITariffOrder;

      if (orderWithAiTariff) {
        await firstValueFrom(this.workflowEndcustomerService.oneApplianceCancelTariffOrder(orderWithAiTariff.name));
      }
      this.resetWorkflow();
    } catch (e) {
      this.resetWorkflow();
    }
  }
}
